"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _lodashEs = require("lodash-es");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var $doc = (0, _jquery2.default)(document);
var scrollTop = 0;

$doc.on("click", ".js-toggle-btn", function (e) {
  e.preventDefault();
  var $this = (0, _jquery2.default)(this);
  var element = $this.data("ref");
  var type = $this.data("type");

  if (type === "expand-search") {
    (0, _jquery2.default)("html").addClass("search-opened");
    (0, _jquery2.default)("body").toggleClass("expand-search");
    (0, _jquery2.default)("body").toggleClass("search-mobile-is-active");

    // calculate search suggestion mobile top outset
    var headerHeight = (0, _jquery2.default)(".header").outerHeight(true);
    var searchPanelHeight = (0, _jquery2.default)(".bc-sf-search-suggestion-mobile-top-panel").outerHeight(true) + headerHeight;

    (0, _jquery2.default)(".bc-sf-search-suggestion-mobile-top-panel").css({
      top: headerHeight + "px"
    });

    // create style tag to overwrite default mobile search styles
    createStyleTag(searchPanelHeight);

    //remove close button event and default class
    if ((0, _jquery2.default)(window).width() <= 767) {
      var $mobileSearchBtn = (0, _jquery2.default)(".bc-sf-search-suggestion-mobile-top-panel").find(".bc-sf-search-btn-close-suggestion");
      $mobileSearchBtn.removeAttr("onclick").removeAttr("class").addClass("bc-sf-search-btn-close-suggestion-custom");
    }

    setTimeout(function () {
      (0, _jquery2.default)(".js-trigger-srch-field").trigger("focus");
    }, 500);

    if (!(0, _jquery2.default)("html").hasClass("no-scroll")) {
      scrollTop = (0, _jquery2.default)(window).scrollTop();
      (0, _jquery2.default)("body").attr("data-top", (0, _jquery2.default)(window).scrollTop()).css("top", -scrollTop);
      (0, _jquery2.default)("html").addClass("no-scroll");
    } else {
      (0, _jquery2.default)("html").removeClass("no-scroll");
      (0, _jquery2.default)("html,body").animate({
        scrollTop: Number((0, _jquery2.default)("body").data("top"))
      }, 0);
    }
  } else {
    (0, _jquery2.default)(element).toggleClass("expanded");

    if ((0, _jquery2.default)(".cart-drawer").hasClass("expanded") && (0, _jquery2.default)(".top-bar--absolute").length) {
      (0, _jquery2.default)(".top-bar--absolute").addClass("display-top-bar-absolute");
      scrollTop = (0, _jquery2.default)(window).scrollTop();
      (0, _jquery2.default)("body").attr("data-top", (0, _jquery2.default)(window).scrollTop()).css("top", -scrollTop);
      (0, _jquery2.default)("html").addClass("no-scroll");
    } else {
      (0, _jquery2.default)(".top-bar--absolute").removeClass("display-top-bar-absolute");
      (0, _jquery2.default)("html").removeClass("no-scroll");
      (0, _jquery2.default)("html,body").animate({
        scrollTop: Number((0, _jquery2.default)("body").data("top"))
      }, 0);
    }
  }
});

(0, _jquery2.default)(".js-go-back-history").on("click", function (e) {
  e.preventDefault();
  history.go(-1);
});

(0, _jquery2.default)(".js-select-page select").on("change", function () {
  var $currentHref = (0, _jquery2.default)(this).find("option:selected").data("page-url");

  window.location.href = $currentHref;
});

$doc.on("click", ".bc-sf-search-btn-close-suggestion", function () {
  console.log(1);
  (0, _jquery2.default)(".bc-sf-search-btn-clear-suggestion").trigger("click");
  (0, _jquery2.default)("body").trigger("click");
});

$doc.on("click", ".bc-sf-search-btn-close-suggestion-custom", function (e) {
  if ((0, _jquery2.default)(window).width() <= 767) {
    e.preventDefault();
    // submit search form mobile
    (0, _jquery2.default)(this).parent().submit();
  }
});

function createStyleTag(searchPanelHeight) {
  var css = ".bc-sf-search-suggestion-mobile.bc-sf-search-suggestion-mobile.bc-sf-search-suggestion-mobile {top:" + searchPanelHeight + "px !important;height:calc(100% - " + searchPanelHeight + "px) !important;}";
  var styleTag = document.createElement("style");
  styleTag.type = "text/css";

  if (styleTag.styleSheet) {
    styleTag.styleSheet.cssText = css;
  } else {
    styleTag.appendChild(document.createTextNode(css));
  }

  (0, _jquery2.default)(".js-search-mobile-styles-overwrite").empty().append(styleTag);
}